import { Row, Col, Button } from "antd";
import React, { Component } from "react";
import PlantOrder from "../../components/DashboardStatsCard/plantorder";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import DeleteOrder from "../../assets/images/delete_order.png";
import { BsCalendarMinus, BsExclamationLg } from "react-icons/all";
import { formatToNumber } from "../../../plant_dir/config/utils";

class LogisticsDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "name",
        status: "pending",
      },
      isClose: false,
      isOpenModal: false,
      isOpenLogisticModal: false,
      userId: "",
      isAllow: "",
    };
  }
  componentDidMount() {
    const { getLogisticOrders } = this.props;

    const companyId = this.props.location?.state?.id;
    if (companyId) {
      getLogisticOrders(this.state.filter, companyId);
    }
  }

  componentDidUpdate(preProps, preState) {
    const { getLogisticOrders } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filter.page !== this.state.filter.page ||
      preState.filter.search !== this.state.filter.search
    ) {
      getLogisticOrders(this.state.filter, this.props.location.state.id);
    }
  }
  toggleModal = () => {
    this.setState({
      isOpenModal: false,
      isOpenLogisticModal: false,
    });
  };

  currentPage = (e) => {
    // this.setState({
    //   filter: {
    //     ...this.state.filter,
    //     page: this.state.filter?.page + 1,
    //   },
    // });
  };

  onChangeTab = (key) => {
    const {
      getLogisticOrders,
      location: { state },
    } = this.props;

    if (key == "1") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "",
        },
      });

      getLogisticOrders({ ...this.state.filter, status: "" }, state.id);
    }
    if (key == "2") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "dispatched",
        },
      });
      getLogisticOrders(
        {
          ...this.state.filter,
          status: "dispatched",
        },
        state.id
      );
    }
    if (key == "3") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "picked",
        },
      });
      getLogisticOrders(
        {
          ...this.state.filter,
          status: "picked",
        },
        state.id
      );
    }
    if (key == "4") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "dropped",
        },
      });
      getLogisticOrders(
        {
          ...this.state.filter,
          status: "dropped",
        },
        state.id
      );
    }
    if (key == "5") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "completed",
        },
      });
      getLogisticOrders(
        {
          ...this.state.filter,
          status: "completed",
        },
        state.id
      );
    }
  };
  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onChangeText = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: e.target.value,
      },
    });
  };

  onChangeFilter = (end_date, start_date) => {
    // this.setState({
    //   filter: {
    //     ...this.state.filter,
    //     start_date,
    //     end_date,
    //   },
    // });
  };
  onChangePeriod = (period) => {
    this.setState({
      filter: {
        ...this.state.filter,
        period,
      },
    });
  };

  handleModal = () => {
    this.state.isOpenModal &&
      this.props.plantActivation(
        this.state.userId,
        () => {
          this.toggleModal();
        },
        "deactivate"
      );
  };

  render() {
    const { isOpenModal, isOpenLogisticModal } = this.state;

    const columns = [
      {
        title: "ORDER DETAILS",
        dataIndex: "",
        align: "left",
        sortDirections: ["descend", "ascend"],
        key: "rmx_product",
        className: "action-class",
        width: "25%",
        sorter: (a, b) =>
          a.order_products[0]?.rmx_product?.name.localeCompare(
            b.order_products[0]?.rmx_product?.name
          ),
        render: (r) => {
          return (
            <div>
              <h1 className="font-w-700">{`Order# ${r?.order_number}`}</h1>
              {r.order_products.map((item, index) => {
                return (
                  <span key={index}>
                    {" "}
                    {(index ? "," : "") + item?.rmx_product?.name}
                  </span>
                );
              })}
            </div>
          );
        },
      },
      {
        title: "CONTRACTOR",
        dataIndex: "",
        align: "left",
        key: "first_name",
        className: "action-class",
        width: "25%",
        sorter: (a, b) =>
          a.contractor?.user?.first_name.localeCompare(
            b.contractor?.user?.first_name
          ),
        render: (r) => {
          return (
            <div>
              <h1 className="font-w-700">{`${r?.contractor?.user?.first_name} ${r?.contractor?.user?.last_name}`}</h1>
              <p>{formatToNumber(r?.contractor?.user?.phone) }</p>
            </div>
          );
        },
      },
      {
        title: "DATE",
        dataIndex: "",
        align: "left",
        className: "action-class",
        width: "25%",
        render: (r) => (
          <div class="chip chips-s">
            <span class="pm-circle am-pm-circle">
              {r?.preferred_delivery_period == "am" ? (
                <BsExclamationLg color="red" size={18} />
              ) : (
                <BsExclamationLg color="grey" size={18} />
              )}
            </span>
            <span style={{ marginRight: "5px" }}>
              <BsCalendarMinus size="12" />
            </span>
            <span>
              {moment(r?.preferred_delivery_datetime).format("MM-DD-YYYY")}
            </span>
          </div>
        ),
      },

      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        className: "action-class",
        width: "25%",
        render: (r) => (
          <p
            className="st-primary pointer-cursor "
            onClick={() => {
              this.props.history.push({
                pathname: `/logistics/${r?.logistics_order?.logistics_partner_id}/orders/${r?.logistics_order?.order_id}`,
              });
              this.props.selectedKey("4");
            }}
            style={{ fontSize: "12px" }}
          >
            DETAILS
          </p>
        ),
      },
    ];
    return (
      <Row justify="space-between">
        <Col span={24}>
          <PlantOrder
            {...this.props}
            inputText={`All Companies > ${this.props?.location?.state?.business_name}  Orders`}
            onChangeTab={this.onChangeTab}
            metaData={this.state.filter}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            onChangeFilter={this.onChangeFilter}
            onChangePeriod={this.onChangePeriod}
            columns={columns}
            isShowLogisticDetail={true}
            isShowPlusSign={true}
            onChangeText={this.onChangeText}
            onClearSearch={() =>
              this.setState({
                filter: { ...this.state.filter, search: "" },
              })
            }
            searchVal={this.state.filter.search}
          />
        </Col>
        <CustomModal
          visible={isOpenModal || isOpenLogisticModal}
          onCancelModal={this.toggleModal}
          footer={[
            <Row justify="center">
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.handleModal()}
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.toggleModal()}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center">
              <img src={DeleteOrder} />
            </Col>
            <Col>
              <p>
                {this.state.isOpenLogisticModal == true
                  ? "Are you sure you want to deactivate this logistic partner?"
                  : "Are you sure you want to deactivate this plant company?"}
              </p>
            </Col>
          </Row>
        </CustomModal>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    logisticOrders: store.DashboardReducer.logisticOrder,
    manufacturePlants: store.DashboardReducer.manufacturePlant,
    user: store.AuthReducer.user,
    metaData: store.DashboardReducer.metaData,
    loading: store.DashboardReducer.isLodadingCount,
    isLoader: store.DashboardReducer.isOrder,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getLogisticOrders: (params, id) =>
      dispatch(DashboardAction.getLogisticsOrderReq(params, id)),
    plantActivation: (id, cb, params) =>
      dispatch(DashboardAction.plantActivationReq(id, cb, params)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
    selectedKey: (e) => dispatch(DashboardAction.getPlantTabProductKeyReq(e)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LogisticsDetails);
